import React from "react";
import styled from "styled-components";
import Skeleton from "../Skeleton";
import { isPositiveNumber } from "src/utils/helpers";
import PrintableLineChart from "../PrintableLineChart";

const CardContainer = styled.div`
    min-width: fit-content;
    max-width: fit-content;
    margin: 1rem 2.5rem 1rem 0;
`;

const ContentContainer = styled.div`
    position: relative;
    height: 100%;
    min-height: 60px;
    margin-right: 30px;
    display: flex;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    height: 100%;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    width: 100px;
`;

const Card = styled.div`
    min-width: 22.5rem;
    max-width: 22.5rem;
    min-height: ${p => p.cardHeight || "180px"};
    background: #FFFFFF 0 0 no-repeat padding-box;
    box-shadow: ${p => p.cardShadow || "0 5px 5px #00000026"};
    border: 1px solid #D8DEEC;
    border-radius: 10px;
`;

const CardHeader = styled.div`
    margin: .5rem 1rem;
    width: fit-content;
    text-align: left;
    font-size: 1.5rem;
    letter-spacing: 0;
    color: #000000;
    opacity: 1;
`;

const Hr = styled.div`
    border: 1px solid #EFEFEF;
`;

const TextLabel = styled.div`
    top: 538px;
    left: 350px;
    width: fit-content;
    height: 38px;
    text-align: left;
    font: normal normal normal 21px Manrope;
    letter-spacing: 0;
    color: #D8DEEC;
    opacity: 1;
    margin: 1rem;
    margin-left: 0.7rem;
`;

const Number = styled.div`
    text-align: left;
    font: normal normal bold 33px Manrope;
    letter-spacing: 0;
    margin: 0.5rem 0.5rem 0.5rem 1.5rem;
    color: #000000;
    opacity: 1;
`;

const NumberPercentage = styled.div`
    text-align: left;
    font-size: 1.5rem;
    letter-spacing: 0;
    margin: 0.5rem 0.5rem 0.5rem 1.5rem;
    color: #02BC77;
    opacity: 1;
`;

const NegativeNumberPercentage = styled.div`
    text-align: left;
    font-size: 1.5rem;
    letter-spacing: 0;
    margin: 0.5rem 0.5rem 0.5rem 1.2rem;
    color: #FF2366;
    opacity: 1;
`;

const SkeletonContainer = styled.div`
    margin: .5rem 1rem;
`;

const LineChartContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
`;

const PrintStatisticsCard = (props, children) => {
    const { header, footer, loadingBaseNumbers, graphData, rate, total, loadingLineGraph, cardHeight, printFormat } = props;
    return (
        <>
            <CardContainer>
                <Card cardHeight={cardHeight} cardShadow={printFormat ? "unset" : "0 5px 5px #00000026;"}>
                    <CardHeader>
                        {loadingBaseNumbers ?
                            <Skeleton variant="Text" width="100px" height="20px" animation="wave" />
                            : header
                        }
                    </CardHeader>
                    <Hr />
                    {loadingBaseNumbers ?
                        <SkeletonContainer>
                            <Skeleton variant="Text" width="50px" height="33px" animation="wave" />
                        </SkeletonContainer>
                        :
                        <ContentContainer>
                            <ContentWrapper>
                                <Number>{total}</Number>
                                {(!rate && rate !== 0) ? "" : (isPositiveNumber(rate) ? <NumberPercentage>+{rate}%</NumberPercentage> : <NegativeNumberPercentage>{rate}%</NegativeNumberPercentage>) }
                            </ContentWrapper>
                            <LineChartContainer>
                                {loadingLineGraph ?
                                    <SkeletonContainer>
                                        <Skeleton variant="Text" width="60px" height="40px" animation="wave" />
                                    </SkeletonContainer>
                                    :
                                    <PrintableLineChart
                                        data={graphData}
                                        isPositive={isPositiveNumber(rate)}
                                    />}
                            </LineChartContainer>
                        </ContentContainer>
                    }
                </Card>
                <TextLabel size=".5rem">
                    {footer}
                </TextLabel>
            </CardContainer>
        </>
    );
};
export default PrintStatisticsCard;